import SectionLabel from "@/components/base/SectionLabel";
import { examplesData } from "@/mocks/homeData";

export default function CasesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-12 md:mb-16 reveal">
          <SectionLabel label={examplesData.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {examplesData.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {examplesData.items.map((item, idx) => (
            <div
              key={item.category}
              className="reveal p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300/60 transition-all duration-300"
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium font-label mb-3">
                {item.category}
              </span>

              <div className="space-y-3 md:space-y-4">
                <div>
                  <p className="text-[10px] md:text-xs font-medium tracking-wider text-foreground-500 font-label mb-1">
                    課題
                  </p>
                  <p className="text-sm md:text-base text-foreground-900 font-medium leading-snug">
                    {item.problem}
                  </p>
                </div>

                <div className="border-t border-background-200/70 pt-3 md:pt-4">
                  <p className="text-[10px] md:text-xs font-medium tracking-wider text-primary-500 font-label mb-1">
                    支援内容
                  </p>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {item.support}
                  </p>
                </div>

                <div className="border-t border-background-200/70 pt-3 md:pt-4">
                  <p className="text-[10px] md:text-xs font-medium tracking-wider text-foreground-500 font-label mb-1">
                    目指す状態
                  </p>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {item.goal}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}